
import Attachment from "../_data/models/Attachment";
export const imageAspectSizeForMaxHeight = (image: Attachment, maxSize: Size): Size => {

    let currentSize: Size = {
        height: image.height,
        width: image.width
    };
    let adjustedSize: Size = maxSize;


    adjustedSize.height = maxSize.height;
    adjustedSize.width = (adjustedSize.height *  currentSize.width)/currentSize.height;

    return adjustedSize;
};


// WEBPACK FOOTER //
// ./app/client/_helpers/imageHelpers.ts